import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
// Meta (Facebook) Pixel
const PIXEL_ID = '931401796468747';
ReactPixel.init(PIXEL_ID);
ReactPixel.pageView();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-296" />);
}